import { createValidateEditableImage } from './validate-editable-image';
import { validateDefaultValue } from '../validate-default-value';
import { validateImageUrl } from '../validate-image-url';

export const validateEditableImage = createValidateEditableImage({ validateImageUrl, validateDefaultValue });
